// extracted by mini-css-extract-plugin
module.exports = {"warningModal":"delete-image_warningModal_6E2Sx"};